import React from "react";

const PageNotFound = () => {
  return <p>Page Not Found</p>;
};

export default PageNotFound;
